
import { Toast } from '@/api/models/Toast'
import { defineComponent, PropType, ref } from 'vue'

export default defineComponent({
  name: 'AppToast',
  props: {
    toast: {
      type: Object as PropType<Toast>
    }
  },
  setup() {
    const hide = ref(false)

    return { hide }
  }
})
